export enum PodMeta {
  MODEL = "pod",
  PK = "id",
}
